module.exports = __webpack_public_path__ + "assets/img/wuzhaung-93e4f549.png";